import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../utils/constants';
import api from '../services/api';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await api.forgotPassword(email);
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'حدث خطأ. حاول مرة أخرى');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="relative z-10 py-20 bg-bg min-h-screen flex items-center">
        <div className="container mx-auto px-4">
          <div className="max-w-[500px] mx-auto">
            <div className="bg-white rounded-3xl shadow-custom-lg p-10">
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center text-white text-4xl mx-auto mb-6">
                  <i className="fas fa-check"></i>
                </div>
                <h1 className="text-2xl font-black text-text mb-4">تم إرسال رابط إعادة التعيين!</h1>
                <p className="text-text3 mb-6">
                  تحقق من بريدك الإلكتروني. أرسلنا لك رابط لإعادة تعيين كلمة المرور.
                </p>
                <p className="text-text3 text-sm mb-6">
                  إذا لم تجد الرسالة، تحقق من مجلد الرسائل غير المرغوب فيها (Spam).
                </p>
                <Link
                  to={ROUTES.LOGIN}
                  className="inline-block px-8 py-4 bg-primary text-white font-bold rounded-xl hover:bg-primary-dark transition-all"
                >
                  العودة لتسجيل الدخول
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="relative z-10 py-20 bg-bg min-h-screen flex items-center">
      <div className="container mx-auto px-4">
        <div className="max-w-[500px] mx-auto">
          <div className="bg-white rounded-3xl shadow-custom-lg p-10">
            <div className="text-center mb-8">
              <div className="w-20 h-20 bg-gradient-to-br from-primary to-secondary rounded-2xl flex items-center justify-center text-white text-3xl mx-auto mb-6">
                <i className="fas fa-key"></i>
              </div>
              <h1 className="text-3xl font-black text-text mb-2">نسيت كلمة المرور؟</h1>
              <p className="text-text3">لا مشكلة! دخل البريد الإلكتروني وراح نبعثلك رابط لإعادة التعيين</p>
            </div>

            {error && (
              <div className="mb-6 p-4 bg-red-50 border-2 border-red-200 rounded-xl text-red-600 text-center">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-text font-bold mb-2">البريد الإلكتروني</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full px-5 py-4 bg-bg border-2 border-border rounded-xl text-text outline-none focus:border-primary transition-colors"
                  placeholder="example@email.com"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full px-8 py-4 bg-primary text-white font-bold rounded-xl hover:bg-primary-dark transition-all shadow-custom hover:shadow-custom-lg disabled:opacity-50"
              >
                {loading ? 'جاري الإرسال...' : 'إرسال رابط إعادة التعيين'}
              </button>
            </form>

            <div className="mt-6 text-center">
              <p className="text-text3">
                تذكرت كلمة المرور؟{' '}
                <Link to={ROUTES.LOGIN} className="text-primary font-bold hover:underline">
                  سجل دخولك
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
